import get from 'lodash.get';

// eslint-disable-next-line no-var, import/no-mutable-exports
export var getLoadingBool = ({ tracker }) => get(tracker, 'results.loading', false);

export const getConnected = ({ tracker }) => get(tracker, 'connected.connected_candidate_details', {});
export const getConnectedMetrics = ({ tracker }) => get(tracker, 'connected.metrics', {});

export const getApplied = ({ tracker }) => get(tracker, 'applied.applied_candidate_details', {});
export const getAppliedMetrics = ({ tracker }) => get(tracker, 'applied.metrics', {});

export const getHired = ({ tracker }) => get(tracker, 'hired.hired_candidate_details', {});
export const getHiredMetrics = ({ tracker }) => get(tracker, 'hired.metrics', {});
